import { Component, Input } from '@angular/core';
import { publicMethods } from '../../../globals';
import { magicPreviewDummyData } from '../../../classes/company';
import { BarChartDataInput } from '../../html-snippet-components/bar-chart/bar-chart.component';

@Component({
    selector: 'aira-bar-chart',
    templateUrl: './aira-bar-chart.component.html',
    styleUrl: './aira-bar-chart.component.css',
    standalone: false
})
export class AiraBarChartComponent {
  @Input() label;
  @Input() data;
  @Input() schema: Record<string, any>;
  @Input() isVertical = true;
  @Input() extraInfo: string[];
  @Input() previewOnly: boolean = false;

  blues = [
    '#02083b',
    '#0c1d51',
    '#203266',
    '#35497c',
    '#4a5e91',
    '#6174a7',
    '#7f90b9',
  ];

  // The child chart rebuilds only when this object's identity changes, so it is
  // stored rather than built inline in the template: a template literal would
  // allocate a new object on every change detection pass.
  chartInput: Partial<BarChartDataInput> = {};

  constructor(public pubMethods: publicMethods) {}

  get displayData() {
    return this.previewOnly ? magicPreviewDummyData.dataForDummyBar : this.data;
  }

  ngOnInit() {
    this.rebuildChartInput();
  }

  ngOnChanges() {
    this.rebuildChartInput();
  }

  rebuildChartInput(): void {
    this.chartInput = {
      series: this.displayData,
      tooltipPrepend: this.schema?.prepend,
      tooltipAppend: this.schema?.append,
      xCategories: this.schema?.axis_labels,
      extraInfo: this.extraInfo,
      colours: this.blues,
    };
  }
}
